import { css } from 'goober';
import React, { memo, useCallback, useState } from 'react';
import fallbackImg from '../../assets/bubble.svg';
import { UIElement } from '../../enums/UIElement';
import State from '../../state';
import colors from '../../styles/colors';
import font from '../../styles/font';
import { transparentize } from '../../styles/mixins';
import Audio from '../Audio';
const StoryInfoContainer = css `
  color: ${colors.white};
  padding: 8px 8px;
  display: flex;
  &.webpeek {
    display: inline-flex;
  }
`;
const StoryIcon = css `
  background: ${transparentize(0.5, colors.black)};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  margin-right: 8px;
  overflow: hidden;
  pointer-events: none;
`;
const Icon = css `
  width: 100%;
  height: 100%;
  display: block;
`;
const InfoContainer = css `
  flex-grow: 1;
  pointer-events: none;
`;
const Name = css `
  font-size: ${font.fontSmall};
  font-weight: ${font.fontWtNormal};
  line-height: 16px;
`;
const SubTitle = css `
  font-size: ${font.fontTiny};
  line-height: 11px;
  color: ${transparentize(0.5, colors.white)};
`;
const BubbleDetails = (props) => {
    const { isHolding, hasAudio, source, bubbleTitle, thumbnailUrl, hiddenElements, isWebpeek, } = props;
    const [storyIcon, setStoryIcon] = useState(thumbnailUrl);
    const { isOnline } = State;
    const setFallbackImg = useCallback(() => {
        setStoryIcon(fallbackImg);
    }, []);
    if (!bubbleTitle || isHolding) {
        return null;
    }
    return (React.createElement("aside", { className: `${StoryInfoContainer}${isWebpeek ? ' webpeek' : ''}` },
        !hiddenElements[UIElement.meatballsIcon] && (React.createElement("div", { className: StoryIcon },
            React.createElement("img", { className: Icon, src: storyIcon, onError: setFallbackImg }))),
        React.createElement("div", { className: InfoContainer },
            !hiddenElements[UIElement.bubbleTitle] && (React.createElement("div", { className: Name }, bubbleTitle)),
            !hiddenElements[UIElement.bubble_SubTitle] && (React.createElement("div", { className: SubTitle }, source))),
        hasAudio && isOnline && !hiddenElements[UIElement.toggleMuteIcon] && (React.createElement(Audio, null))));
};
BubbleDetails.defaultProps = {
    hiddenElements: {},
};
const shouldNotReRender = (prevProps, nextProps) => {
    return !(prevProps.isHolding !== nextProps.isHolding ||
        prevProps.hasAudio !== nextProps.hasAudio ||
        prevProps.source !== nextProps.source);
};
export default memo(BubbleDetails, shouldNotReRender);
//# sourceMappingURL=index.js.map